import { ADDITIONAL_DETAILS_EVENTS } from './additional_details';
import { ADDITIONAL_PARTICIPANT_EVENTS } from './additional_participant';
import { AUCTION_EVENTS } from './auction_bidding';
import { CATALOGUE_EVENTS } from './properties_in_catalogue';
import { FAVOURITES_EVENTS } from './favourites_state';
import { UPLOADERS_EVENTS } from './uploaders';
import { PAY_BY_CARD_EVENTS } from './pay_by_card';
import { MULTISELECT_EVENTS } from './multiselect';
import { WINDOW_EVENTS } from './window';
import { NEWSLETTER_SUBSCRIPTION_EVENTS } from './newsletter_subscription';
import { LEGAL_DOCUMENTS_EVENTS } from './legal_documents';
import { GRID_VIEW_FILTERS_EVENTS } from './grid_view_filters';
import { BODY_STYLES_EVENTS } from './body_styles';
import { MAKE_AN_OFFER_EVENTS } from './make_an_offer';
import { ARP_NAVIGATION_EVENTS } from './auction_registration_navigation';

$(() => {
  ADDITIONAL_DETAILS_EVENTS.initializeEventListeners();
  ADDITIONAL_PARTICIPANT_EVENTS.initializeEventListeners();
  AUCTION_EVENTS.initializeEventListeners();
  CATALOGUE_EVENTS.initializeEventListeners();
  FAVOURITES_EVENTS.initializeEventListeners();
  UPLOADERS_EVENTS.initializeEventListeners();
  PAY_BY_CARD_EVENTS.initializeEventListeners();
  MULTISELECT_EVENTS.initializeEventListeners();
  WINDOW_EVENTS.initializeEventListeners();
  NEWSLETTER_SUBSCRIPTION_EVENTS.initializeEventListeners();
  LEGAL_DOCUMENTS_EVENTS.initializeEventListeners();
  GRID_VIEW_FILTERS_EVENTS.initializeEventListeners();
  BODY_STYLES_EVENTS.initializeEventListeners();
  MAKE_AN_OFFER_EVENTS.initializeEventListeners();
  ARP_NAVIGATION_EVENTS.initializeEventListeners();
});
